import compose from 'hoc';
import { withCommonHookProviders, withRouterHooksProviders } from 'hooks';

export const withCommonProviders = compose(withCommonHookProviders);
export const withRouterProviders = compose(withRouterHooksProviders);
